<template>
    <div>
        <div class="flex justify-between items-center mb-6">
            <div class="flex cursor-pointer text-green-600 hover:text-green-700" @click="goBack">
                <i class='bx bx-left-arrow-alt bx-sm my-auto'></i>
                <p class="text-xl font-semibold">Chi tiết tin tức</p>
            </div>
        </div>
        <div class="entry-detail flex flex-col gap-4">
            <div class="flex flex-col md:flex-row justify-between">
                <p class=""><b>Tin tức</b>: {{ entry.name }}</p>
                <p class=""><b>Danh mục</b>: {{ entry.type }}</p>
                <p class=""><b>Cập nhật</b>: {{ getDateTime(entry.createdAt) }}</p>
            </div>
            <img v-if="entry.image" :src="$addPrefix(entry.image)" 
                class="sm:w-[400px] sm:h-[250px] md:w-[600px] md:h-[350px] object-cover mx-auto" 
                v-viewer alt @error="replaceBrokenImage"
            >
            <p class="text-justify text-lg" v-html="entry.description"></p>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import list from "@/mixins/list";
export default {
    name: 'detail',
    mixins: [list],
    data() {
        return {
            entry: {
                name: '',
                description: '',
                type: null,
                image: ''
            }
        }
    },
    methods: {
        ...mapActions('news', ['GetNews']),
        goBack() {
            this.$router.push({
				name: "admin." + this.$route.name.split(".")[1],
			});
        },
        async getEntry() {
            let response = await this.GetNews(this.$route.params.id)
            this.entry = response.data.data
        }
    },
}
</script>
<style>

</style>